import React, { useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import { FarmtranningInfoNew } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcCamcorderPro } from "react-icons/fc";

import { FarmTranningSchema } from "../../../Schemas/Farm Traning Schema/farm_tranning_schema";

const CreateDriveFolder = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handelSubmit = (values, actions) => {
    setLoading(true);
    performRequest("POST", "/farmmediadrive/folder", {
      folderName: values?.farmTrainingFolder,
    })
      .then((res) => {
        if (res.status) {
          Toast("success", "Drive Created Successfully!");
          navigate(`/get-folders`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="text-center">
              <h1>
                <FcCamcorderPro
                  className="me-2"
                  style={{ height: "30px", width: "30px" }}
                ></FcCamcorderPro>
                Create Farm Training Drive
              </h1>
              <hr></hr>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  The system will automatically create a Farm Training Drive
                  folder using the selected training date. All selected
                  participants’ data and uploaded media will be organized and
                  stored inside the generated folder.
                  <br></br>
                  <br></br>
                  <br></br>
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={FarmtranningInfoNew}
                  validationSchema={FarmTranningSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Farm Tranning Date
                          </label>
                          {console.log(props.values)}
                          <div className="w-100 col">
                            <CustomInput
                              name="farmTrainingDate"
                              type="date"
                              onChange={(e) => {
                                const selectedDate = e.target.value;

                                props.setFieldValue(
                                  "farmTrainingDate",
                                  selectedDate
                                );
                                props.setFieldValue(
                                  "farmTrainingFolder",
                                  `Farm Training / ${selectedDate}`
                                );
                              }}
                            />

                            {props.touched.farmTrainingDate &&
                              props.errors.farmTrainingDate && (
                                <p className="text-danger">
                                  {props.errors.farmTrainingDate}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Farm Tranning Folder
                          </label>
                          {props.values.farmTrainingDate ? (
                            <div className="w-100 col">
                              <p>{`Farm Tranning / ${props.values.farmTrainingDate}`}</p>
                            </div>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create folder" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default CreateDriveFolder;
